import VueEvaIcons from 'vue-eva-icons';

const evaIcons = {
  install(Vue) {
    Vue.use(VueEvaIcons);
  },
};

export default evaIcons;
